import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import SubscriptionForm from '@components/SubscriptionForm';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';
import { OfferOption } from '@utils/backend-api/subscribe';
import { FormLocation } from '@utils/enums';

import CorporateInquiry from './OfferSelection/CorporateInquiry';
import Offer from './OfferSelection/Offer';
import StaticBenefits from './OfferSelection/StaticBenefits';

interface SingleOffersProps {
  description?: string;
  offer: OfferOption;
}

const SingleOffer = ({ description, offer }: SingleOffersProps) => {
  const { code, header, isPro, subHeader } = offer;
  const { Track } = useEventTracking({ page: Page.SingleOfferSubscribe });

  return (
    <Track>
      <div className="px-16 pb-80 pt-32 sm:px-28 sm:pb-96 sm:pt-48 lg:pb-112 lg:pt-64">
        <div className="mx-auto max-w-full lg:max-w-[1040px]">
          <div className="mb-48 grid grid-cols-1 gap-32 sm:gap-48 md:grid-cols-2 lg:gap-64">
            <div>
              <h2 className="m-0 font-suisse-works text-headline-md text-black sm:text-headline-xl">
                {ReactHtmlParser(header)}
              </h2>
              <p className="mb-0 mt-8 font-suisse-neue text-body-lg text-black sm:mt-16 md:mb-32">
                {description || ReactHtmlParser(subHeader)}
              </p>
              <StaticBenefits className="hidden md:block" isPro={isPro} />
            </div>
            <div className="m-auto w-full xs:max-w-md md:max-w-full">
              <div className="mx-16 mb-32 xs:mx-auto">
                <Offer offer={offer} isSingleOffer selectedOfferCode={code} />
              </div>
              <StaticBenefits className="mx-auto block md:hidden" isPro={isPro} />
              <SubscriptionForm
                buttonText="Subscribe"
                formLocation={FormLocation.Subscribe}
                presentedOfferCodes={[code]}
                selectedOffer={offer}
              />
            </div>
          </div>
          <CorporateInquiry />
        </div>
      </div>
    </Track>
  );
};

export default SingleOffer;
